const matchMedia = (win, query) => win.matchMedia ? win.matchMedia(query).matches : false;
export const checkTouch = (win) => matchMedia(win, '(any-pointer:coarse)');
